module.exports = __webpack_public_path__ + "img/house-signal.66a38425.svg";